import { useContext } from 'react';
import {
  CreateLogRequest,
  ManuallyLoggedErrorType,
} from '../features/common/Common.types';
import { buildErrorDetails, logError } from '../features/common/Common.utils';
import { ConfigurationContext } from '../providers/ConfigurationProvider';
import Logger from '../shared/logger/logger';

export interface LogErrorParams {
  err: any;
  errDetails?: ManuallyLoggedErrorType | undefined;
}

interface UseLogActionResponse {
  logError: (params: LogErrorParams) => void;
  logAction: (params: CreateLogRequest) => void;
}

export const useLogAction = (): UseLogActionResponse => {
  const config = useContext(ConfigurationContext);
  const apiURL = config?.API_URL || '';
  const logErrFunc = ({ err, errDetails }: LogErrorParams): void => {
    const errMsg = err ? (err.message ? err.message : JSON.stringify(err)) : '';
    logError({
      apiURL,
      errorMessage: errMsg,
      errorStack: buildErrorDetails(errDetails),
    });
  };

  const logActionFunc = ({
    action,
    message,
    detail,
  }: CreateLogRequest): void => {
    const logger = new Logger(apiURL);
    logger.logAction({
      action,
      message: message ?? '',
      detail: detail ?? '',
    });
  };

  return {
    logError: logErrFunc,
    logAction: logActionFunc,
  };
};
